import Config from "../Config";
import OccupationMaster from "../data/constant/occupation_master";
import StateMaster from "../data/constant/state_master";
import CityMaster from "../data/constant/city_master";
import CountryMaster from "../data/constant/country_master";
import NationalityMaster from "../data/constant/nationality_master";
import GeneralWebService from "../service/general_web_service";
import Labels from "../ui/constant/labels";
import LanguageBloc from "./language_bloc";
import DataResult from "../data/bean/data_result";
import ProposalServices from "../service/proposal_web_services";
import GeneralBloc from "./general_bloc";
import AuthBloc from "./auth_bloc";

export default class FormBloc {

  static async getOccupationClass(occupationCode, NOBCode) {
    let resp = await ProposalServices.getOccupationClass(
      occupationCode,
      NOBCode
    );

    if (resp.success) {
      return resp.data;
    } else {
      return [];
    }
  }

  static allowToShowNewFields(productCode) {
    let show = true;
    let newFields = GeneralBloc.getJsonContent().quotation.quotationViewSteps[1].newFields;
    if (productCode) {
      show = newFields.includes(productCode);
    }
    return show
  }

  //If is NRIC or if(value=="ORIC" || value=="PASP" || value=="OTHR")
  static isTypeNRICFormat(value) {
    if (value == "ORIC" || value == "PASP" || value == "OTHR") {
      return false
    } else {
      return true
    }
  }

  //geDefermentPeriodList
  static geDefermentPeriodList() {
    return [
      { description: "0", description1: "0", code: "0" },
      { description: "1", description1: "1", code: "1" },
      { description: "2", description1: "2", code: "2" },
      { description: "3", description1: "3", code: "3" },
      { description: "4", description1: "4", code: "4" },
      { description: "5", description1: "5", code: "5" },
    ];
  }

  //getPaymentMethodList
  static getPaymentMethodList() {
    return [
      {
        description: "Cash / Check",
        description1: "Cash / Check",
        code: "Cash / Check",
      },
    ];
  }

  //getPaymentFrequencyList
  static getPaymentFrequencyList() {
    return [
      {
        description: "Single Premium",
        description1: "Single Premium",
        code: "Single Premium",
      },
    ];
  }

  //getProductSelectionList
  static getProductSelectionList() {
    return [
      {
        description: "Non Participating",
        description1: "Non Participating",
        code: "Non Participating",
      },
      {
        description: "Mortgage Cover",
        description1: "Mortgage Cover",
        code: "Mortgage Cover",
      },
    ];
  }

  //getNobListing depend on occupationCode
  static async getNobListing(occupationCode) {
    let resp = await ProposalServices.getNobListing(occupationCode);
    let data = [];
    let list = resp.data;
    let language = LanguageBloc.getSelectedLanguage();
    //Sort by Alphabetical order
    if (language == Config.locale.en) {
      list.sort((a, b) => a.reference1.localeCompare(b.reference1));
    } else {
      list.sort((a, b) => a.reference2.localeCompare(b.reference2));
    }

    list.map((item) => {
      if (item.status == "ACTIVE" && item.reference1 && item.reference2) {
        data.push({
          description: item.reference1,
          description1: item.reference2,
          description2: item.reference3,
          code: item.code,
        });
      }
    });

    if (resp.success) {
      return data;
    } else {
      return [];
    }
  }

  //Return EN or BM version for selected occupation
  static getProcessedOccupationValue(value, list) {
    if (value != null) {
      let currentLang = LanguageBloc.getSelectedLanguage();
      let returnValue = value;
      let occList = list;
      occList.map((occ) => {
        if (value === occ.description || value === occ.description1) {
          if (currentLang == "EN") {
            returnValue = occ.description;
          } else {
            returnValue = occ.description1;
          }
        }
      });
      return returnValue;
    }
  }

  //checkFileNameExtension allow
  static checkFileNameExtension(filename) {
    if (
      !filename.endsWith(".jpg") &&
      !filename.endsWith(".png") &&
      !filename.endsWith(".jpeg") &&
      !filename.endsWith(".pdf") &&
      !filename.endsWith(".JPG") &&
      !filename.endsWith(".PNG") &&
      !filename.endsWith(".JPEG") &&
      !filename.endsWith(".PDF")
    ) {
      return;
    }
  }

  static getFormFieldsFromConfig(formSetup, fieldsConfig) {
    let formFields = [];
    if (formSetup && formSetup.length > 0) {
      formSetup.map((ev, index) => {
        if (
          ev.id == fieldsConfig[ev.id] ||
          ev.id.toUpperCase() == fieldsConfig[ev.id]
        ) {
          formFields.push(fieldsConfig[ev.id]);
        }
      });
      return formFields;
    } else {
      return [];
    }
  }

  //Get city by code
  static getCityByZipCode(zipCode) {
    for (let i = 0; i < CityMaster.cities.length; i++) {
      let item = CityMaster.cities[i];
      if (item.postCode == zipCode) return item;
    }
    return null;
  }

  //Get state by code
  static getStateByCode(code) {
    for (let i = 0; i < StateMaster.states.length; i++) {
      let item = StateMaster.states[i];
      if (item.stateCode == code) return item;
    }
    return null;
  }

  //Get states
  static getStateSelections() {
    return StateMaster.states;
  }

  //Get cities
  static getCitySelections() {
    return CityMaster.cities;
  }

  //Get countries
  static getCountrySelections(other) {
    let countries=[];
    CountryMaster.countries.map((item)=>{
      countries.push({
        code: item.code,
        description: item.name,
        description1:item.name,
        description2:item.name,
      })
    })
    return countries;
  }

  static getOtherCountrySelections(other) {
    let countries=[];
    CountryMaster.countries.map((item,index)=>{
      if(index>0){
        countries.push({
          code: item.code,
          description: item.name,
          description1:item.name,
          description2:item.name,
        })
      }      
    })
    return countries;
  }

  //Get nationalities
  static getNationalitySelections() {
    let nationalities=[];
    NationalityMaster.nationalities.map((item)=>{
      nationalities.push({
        code: item.code,
        description: item.name,
        description1:item.name,
        description2:item.name,
      })
    })
    return nationalities;
  }

  //Get country by code
  static getCountryByCode(code) {
    for (let i = 0; i < CountryMaster.countries.length; i++) {
      let item = CountryMaster.countries[i];
      if (item.code == code) return item;
    }
    return null;
  }

  static sortByKey(array, key) {
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }



  static async getMasterDataWithCodeOriginal(param) {
    let list = [];
    let language = LanguageBloc.getSelectedLanguage();
    let resp = await GeneralWebService.getMasterDataWithCode(param);
    if (resp.success) {
      list = resp.data;
    }

    return list;
  }

  static async getMasterDataWithCode(param, option) {
    let newList = [];
    let language = LanguageBloc.getSelectedLanguage();
    let resp = await GeneralWebService.getMasterDataWithCode(param);
    if (resp.success) {
      let list = resp.data;
      //Sort by Alphabetical order
      if (language == Config.locale.en) {
        list.sort((a, b) => a.reference1.localeCompare(b.reference1));
      } else {
        list.sort((a, b) => a.reference2.localeCompare(b.reference2));
      }

      let others = null;

      list.map((item) => {
        if (item.status == "ACTIVE" && item.reference1 && item.reference2) {
          if (item.code != "Others") {
            newList.push({
              description: item.reference1,
              description1: item.reference2,
              description2: item.reference3,
              code: item.code,
              extra: {
                compulsoryYes: item.extra.compulsoryYes,
                group: item.extra.group,
              },
            });
          } else {
            others = {
              description: item.reference1,
              description1: item.reference2,
              description2: item.reference3,
              code: item.code,
              extra: {
                compulsoryYes: item.extra.compulsoryYes,
                group: item.extra.group,
              },
            };
          }
        }
      });
      if (others) {
        newList.push(others);
      }
    }

    return newList;
  }

  static swapElements(array, index1, index2) {
    let temp = array[index1];
    array[index1] = array[index2];
    array[index2] = temp;
    return array
  };

  static async getMasterDataWithCodeRace(param, option) {
    return [{ "description": "Malay", "description1": "Malay", "description2": "", "code": "Malay", "extra": {} },
    { "description": "Chinese", "description1": "Chinese", "description2": "", "code": "Chinese", "extra": {} },
    { "description": "Indian", "description1": "Indian", "description2": "", "code": "Indian", "extra": {} },
    { "description": "Others", "description1": "Others", "description2": "", "code": "Others", "extra": {} }];
  }

  static async getMasterDataWithCodeSalutation(param, option) {
    let newList = [];
    let language = LanguageBloc.getSelectedLanguage();
    let resp = await GeneralWebService.getMasterDataWithCode(param);
    if (resp.success) {
      let list = resp.data;
      let others = null;

      list.map((item) => {
        if (item.status == "ACTIVE" && item.reference1 && item.reference2) {
          if (item.code != "Others") {
            newList.push({
              description: item.reference1,
              description1: item.reference2,
              description2: item.reference3,
              code: item.code,
              extra: {
                compulsoryYes: item.extra.compulsoryYes,
                group: item.extra.group,
              },
            });
          } else {
            others = {
              description: item.reference1,
              description1: item.reference2,
              description2: item.reference3,
              code: item.code,
              extra: {
                compulsoryYes: item.extra.compulsoryYes,
                group: item.extra.group,
              },
            };
          }
        }
      });
      if (others) {
        newList.push(others);
      }
    }

    return newList;
  }

  static async getMasterDataWithCodeOccupation(param, option) {
    let newList = [];
    let language = LanguageBloc.getSelectedLanguage();
    let resp = await GeneralWebService.getMasterDataWithCode(param);
    if (resp.success) {
      let list = resp.data;
      //Sort by Alphabetical order
      if (language == Config.locale.en) {
        list.sort((a, b) => a.reference1.localeCompare(b.reference1));
      } else {
        list.sort((a, b) => a.reference2.localeCompare(b.reference2));
      }

      let others = null;

      list.map((item) => {
        if (item.status == "ACTIVE" && item.reference1 && item.reference2) {
          if (item.code != "Others") {
            newList.push({
              description: item.reference1,
              description1: item.reference2,
              description2: item.reference3,
              code: item.code,
              extra: {
                compulsoryYes: item.extra.compulsoryYes,
                group: item.extra.group,
              },
            });
          } else {
            others = {
              description: item.reference1,
              description1: item.reference2,
              description2: item.reference3,
              code: item.code,
              extra: {
                compulsoryYes: item.extra.compulsoryYes,
                group: item.extra.group,
              },
            };
          }
        }
      });
      if (others) {
        newList.push(others);
      }
    }

    return newList;
  }

  static async getMasterDataWithCodeOccupationNob(param, option) {
    let newList = [];
    let language = LanguageBloc.getSelectedLanguage();
    let resp = await GeneralWebService.getMasterDataWithCode(param);
    if (resp.success) {
      let list = resp.data;
      //Sort by Alphabetical order
      if (language == Config.locale.en) {
        list.sort((a, b) => a.reference1.localeCompare(b.reference1));
      } else {
        list.sort((a, b) => a.reference2.localeCompare(b.reference2));
      }

      let others = null;

      list.map((item) => {
        if (item.status == "ACTIVE" && item.reference1 && item.reference2) {
          if (item.code != "Others") {
            newList.push({
              description: item.reference2,
              description1: item.reference2,
              description2: item.reference3,
              code: item.code,
              extra: {
                compulsoryYes: item.extra.compulsoryYes,
                group: item.extra.group,
              },
            });
          } else {
            others = {
              description: item.reference2,
              description1: item.reference2,
              description2: item.reference3,
              code: item.code,
              extra: {
                compulsoryYes: item.extra.compulsoryYes,
                group: item.extra.group,
              },
            };
          }
        }
      });
      if (others) {
        newList.push(others);
      }
    }

    return newList;
  }

  static async getMasterDataWithCodeForCountryCode(param) {
    let newList = [];
    let language = LanguageBloc.getSelectedLanguage();
    let resp = await GeneralWebService.getMasterDataWithCode(param);
    if (resp.success) {
      let list = resp.data;
      //console.log("LISTCOUNTRY", list);
      //Sort by Alphabetical order
      if (language == Config.locale.en) {
        list.sort((a, b) => a.reference3.localeCompare(b.reference3));
      } else {
        list.sort((a, b) => a.reference3.localeCompare(b.reference3));
      }

      let malaysia = null;
      //console.log("LISTCOUNTRYSORTED", list);
      list.map((item) => {
        if (item.status == "ACTIVE" && item.reference1 && item.reference2) {
          if (item.code != "MYS") {
            newList.push({
              description: "+(" + item.reference1 + ")" + ` ${item.reference3}`,
              description1:
                item.code,
              description2: item.reference3,
              code: item.reference1,
            });
          } else {
            malaysia = {
              description: "+(" + item.reference1 + ")" + ` ${item.reference3}`,
              description1: item.code,
              description2: item.reference3,
              code: item.reference1,
            };
          }
        }
      });
      if (malaysia) {
        newList.unshift(malaysia);
      }
    }
    //console.log("newList",newList)
    return newList;
  }

  static getProcessedOccupationValue(value) {
    if (value != null) {
      let returnValue = value;
      let occList = this.getOccupationSelections();
      occList.map((occ) => {
        if (value === occ.description || value === occ.description1) {
          returnValue = occ.description;
        }
      });
      return returnValue;
    }
  }

  static getEligibleOptions() {
    return [
      {
        code: "YES",
        label: "Yes",
      },
      {
        code: "NO",
        label: "No",
      },
    ];
  }

  static getRefundPremiumRider() {
    return [
      {
        code: sessionStorage.getItem("ropCode") ? sessionStorage.getItem("ropCode"):"RP05",
        label: "Yes",
      },
      {
        code: "",
        label: "No",
      },
    ];
  }

  static getPaymentModeOptions() {
    return [
      {
        code: "S",
        label: "Non-Financing",
      },
      {
        code: "B",
        label: "Financing",
      },
    ];
  }

  static getCurrentLivingInMalayOptions() {
    return [
      {
        code: "Yes",
        label: "Yes",
      },
      {
        code: "No",
        label: "No",
      },
    ];
  }

  static getYesNoOptions() {
    return [
      {
        code: "Yes",
        label: "Yes",
      },
      {
        code: "No",
        label: "No",
      },
    ];
  }

  static getOtpModeOptions() {
    return [
      {
        code: "SMS",
        label: "SMS",
      },
      {
        code: "EMAIL",
        label: "EMAIL",
      },
    ];
  }

  static getSmokerOptions() {
    return [
      {
        code: "Yes",
        label: "Smoker",
      },
      {
        code: "No",
        label: "Non Smoker",
      },
    ];
  }

  static getSelfOrBranchOptions(party,productCode) {
    if(party=="3P"){
      return [
        {
          code:productCode=="LOP" ? "Self": "Proposed Insured Member",
          description:productCode=="LOP" ? "Self": "Proposed Insured Member",
          description1:productCode=="LOP" ? "Self": "Proposed Insured Member",
        },
        {
          code: "Branch",
          description: "Branch",
          description1: "Branch",
        },
      ];
    } else {
      return [
        {
          code: "Company of the Proposed Insured Member",
          description: "Company of the Proposed Insured Member",
          description1: "Company of the Proposed Insured Member",
        },
        {
          code: "Branch",
          description: "Branch",
          description1: "Branch",
        },
      ];
    }
    
  }

  static getQuotationSteps() {
    return [
      "Personal Details",
      "Financial Details",
      "Takaful Details",
      "Review and Submit",
    ];
  }

  static getProposalSteps() {
    return [
      "Provide Details",
      "Upload Documents",
      "Review",
      "Consent and Declaration",
    ];
  }

  static getProposalMortgageDetails(data,productSelection,assumedLoanInterestRate) {
    //console.log("getProposalMortgageDetails", data);
    //console.log("getProposalMortgageDetails1", productSelection);
    return {
      purposeOfProposal: productSelection?.purposeOfProposal ?? null,
      planName: productSelection?.productSelection ?? null,
      insuranceType: productSelection?.insuranceType ?? null,
      arrangement: productSelection?.arrangement ?? null,
      paymentMode: productSelection?.paymentMode ?? null,
      loanAccountNo: data?.loanAccountNo,
      loanInterestRate: assumedLoanInterestRate || data?.loanInterestRate,
      premiumAmount: data?.totalPremium,
      basicAmount: data?.basicPremium,
      ropAmount: data?.ropPremium == "0.00" ? "-" : data?.ropPremium,
      totalAmount: data?.totalPremium,
      sumAssured: data?.initialSumAssured || data?.coverageAmount,
      loanAmount: data?.loanAmount,
      termOfCoverage:data?.termOfCoverage || data?.certificateTerm,
      constructionPeriod: data?.defermentPeriod || data?.defermentTerm,
    };
  }

  static getProposalSalesRepresentativeDetails(
    dataProfile,
    dataSalesRepresentativeDetail
  ) {
    //console.log("dataProfile", dataProfile)
    //console.log("dataProfile1", dataSalesRepresentativeDetail)//
    const session = AuthBloc.checkSession();
    let ChannelId =session.data.meta.metadata.attributes?.subChannel;
    return {
      salesRepresentativeName: dataProfile?.name ?? dataSalesRepresentativeDetail?.name ?? "",
      salesRepresentativeStaffID: dataProfile?.clientId ?? dataSalesRepresentativeDetail?.clientId ?? "",
      salesRepresentativeID: dataProfile?.salesRepId ?? dataSalesRepresentativeDetail?.salesRepId ?? "",
      salesRepresentativeAgentCode: dataProfile?.salesRepCode ?? dataSalesRepresentativeDetail?.salesRepCode ?? "",
      salesRepresentativeMobileNumber: dataProfile?.contactNumber ?? "",
      salesRepresentativeEmail: dataProfile?.emailAddress ?? "",
      section: dataProfile?.section ?? "",
      branchCode: dataProfile?.branchCode ?? dataSalesRepresentativeDetail?.branchCode ?? "",
      bankName: dataProfile?.bankName ?? dataSalesRepresentativeDetail?.bankName ?? "",
      referralCode: dataSalesRepresentativeDetail?.referralCode ?? "",
      referralBranchCode: dataSalesRepresentativeDetail?.referralBranchCode ?? "",
      campaignCode: dataSalesRepresentativeDetail?.campaignCode ?? "",
      underB40Group: dataSalesRepresentativeDetail?.underB40Group ?? { code: 'No', label: 'No' },
      useCampaignCode: dataSalesRepresentativeDetail?.useCampaignCode ?? { code: 'No', label: 'No' },
      useSectorCode:(dataSalesRepresentativeDetail?.useSectorCode ?? ""), //(ChannelId == "BB" || ChannelId == "CBD") ? { code: 'No', label: 'No' } : (dataSalesRepresentativeDetail?.useSectorCode ?? ""),
      sectorCode: dataSalesRepresentativeDetail?.sectorCode ?? "",
    };
  }

   static areAddressesSame(employerAddress, correspondenceAddress) {
    // Check if both addresses are null or undefined
    if (!employerAddress || !correspondenceAddress) {
      return false; // Return false if any of the addresses is null or undefined
    }
  
    // Compare country details, using optional chaining (?.) to handle undefined or null values
    const isCountrySame = employerAddress.country?.code === correspondenceAddress.country?.code &&
                          employerAddress.country?.description === correspondenceAddress.country?.description &&
                          employerAddress.country?.description1 === correspondenceAddress.country?.description1 &&
                          employerAddress.country?.description2 === correspondenceAddress.country?.description2;
  
    // Compare city details
    const isCitySame = employerAddress.city?.postCodeInt === correspondenceAddress.city?.postCodeInt &&
                       employerAddress.city?.cityName === correspondenceAddress.city?.cityName &&
                       employerAddress.city?.stateCode === correspondenceAddress.city?.stateCode &&
                       employerAddress.city?.postCode === correspondenceAddress.city?.postCode;
  
    // Compare state details
    const isStateSame = employerAddress.state?.stateCode === correspondenceAddress.state?.stateCode &&
                        employerAddress.state?.stateName === correspondenceAddress.state?.stateName;
  
    // Compare line1 (address line) and postCode
    const isLine1Same = employerAddress.line1 === correspondenceAddress.line1;
    const isPostCodeSame = employerAddress.postCode === correspondenceAddress.postCode;
  
    // Check if all details are the same
    return isCountrySame && isCitySame && isStateSame && isLine1Same && isPostCodeSame;
  }

  // Map data from Proposal detail to be auto populated
  static getProposalPersonalDetails(data, dataImport) {    
    return data ? {
      title: data?.title,
      muslim :data?.muslim,
      name: data.name,
      gender: data?.gender || null,

      typeId: dataImport ? dataImport.typeId || null : data?.typeId || null,

      idNo: dataImport ? dataImport.idNo || null : data?.idNo || null,
      /* otherIdNo: data.otherIdNo, */
      dob: data.dob,
      anb: data.anb,

      maritalStatus: dataImport ? dataImport.maritalStatus || "" : data?.maritalStatus || "",

      race: dataImport ? dataImport.race || "" : data?.race || "",

      nationality: dataImport ? dataImport.nationality || null : data?.nationality || null,


      countryOfBirth: dataImport ? dataImport.countryOfBirth || "" : data?.countryOfBirth || "",


      height: dataImport ? dataImport.height || null : data?.height || null,

      weight: dataImport ? dataImport.weight || null : data?.weight || null,

      smoked: data?.smoked || "",
      typeCigarettes:data?.typeCigarettes || null,
      sticksPerDay: dataImport ? dataImport.sticksPerDay || "" : data?.sticksPerDay || "",

      yearsOfSmoked: dataImport ? dataImport.yearsOfSmoked || "" : data?.yearsOfSmoked || "",

      occupation: data?.occupation || "",
      occupationExactDuty: dataImport ? dataImport.occupationExactDuty || "" : data?.occupationExactDuty || "",

      nob: data?.nob || "",

      annualIncome: dataImport ? dataImport.annualIncome || "" : data?.annualIncome || "",
      tin: dataImport ? dataImport.tin || "" : data?.tin || "",
      sst: dataImport ? dataImport.sst || "" : data?.sst || "",
      fileTaxReturn:dataImport ? dataImport.fileTaxReturn || "" : data?.fileTaxReturn || null,
      taxReturnOtherCountry: dataImport ? dataImport.taxReturnOtherCountry || "" : data?.taxReturnOtherCountry || null,
      taxReturnOtherCountryValues:dataImport ? dataImport.taxReturnOtherCountryValues || "" : data?.taxReturnOtherCountryValues || null,

      purposeOfProposal: data?.purposeOfProposal || "",
      relationship: dataImport ? dataImport.relationship : "Self",      
      isEmployerSameAsCorrespondence: dataImport ? dataImport.isEmployerSameAsCorrespondence : data?.isEmployerSameAsCorrespondence,
      employerName: dataImport ? dataImport.employerName : data?.employerName,
      email: data?.email || "",
      mobileNumber: dataImport ? dataImport.mobileNumber || "" : data?.mobileNumber || "",
      businessContact: dataImport ? dataImport.businessContact || "" : data?.businessContact || "",

      residenceContact: dataImport ? dataImport.residenceContact || "" : data?.residenceContact || "",
      countryCodeMobile: dataImport ? dataImport.countryCodeMobile || "" : data?.countryCodeMobile || "",

      countryCodeResidenceTel: dataImport ? dataImport?.countryCodeResidenceTel || "" : data?.countryCodeResidenceTel || "",
      countryCodeBusinessTel: dataImport ? dataImport.countryCodeBusinessTel || "" : data?.countryCodeBusinessTel || "",

      insuranceCertificateDelivery: dataImport ? dataImport.insuranceCertificateDelivery : data?.insuranceCertificateDelivery,
      employerAddress: dataImport ? dataImport.employerAddress : data?.employerAddress,
      correspondenceAddress: dataImport ? dataImport.correspondenceAddress : data?.correspondenceAddress || data?.corresAddress,
      residentAddress: dataImport ? dataImport.residentAddress : data?.residentAddress,
      isResidentSameAsCorrespondence: dataImport ? (dataImport?.isResidentSameAsCorrespondence ||
        data?.residentialAddressSameCorresAddress) :
        (data?.isResidentSameAsCorrespondence ||
          data?.residentialAddressSameCorresAddress),
      salutation: "",
    } : null;
  }

  // Map data from Company detail to be auto populated  
  static getProposalCompanyDetails(data,personalDetails) {
    //console.log("dataImport", data)

    return data ? {
      registeredNameCompany: data.registeredNameCompany,
      newCompanyRegistrationNo: data.newCompanyRegistrationNo,
      oldCompanyRegistrationNo: data.oldCompanyRegistrationNo,
      companyCountry: data.companyCountry,      
      isCompanySameAsCorrespondence: this.areAddressesSame(data?.companyAddress,personalDetails?.correspondenceAddress) ? {
        "code":"Yes",
        "label":"Yes"
      } : {
        "code":"No",
        "label":"No"
      },
      companyAddress: data.companyAddress || null,
      tin:data.tin || null,
      sst:data.sst || null,
      countryCodeMobile: data.countryCodeMobile || null,
      companyTel: data.companyTel || null,
      companyEmail: data.companyEmail || null,
      insuranceCertificateDelivery:data.insuranceCertificateDelivery,
      companyType: data.companyType || null,
      provideDetail: data.provideDetail || null,
      listedOrTradeStockExChange: data.listedOrTradeStockExChange || null,
      fileTaxReturn:data.fileTaxReturn || null,
      usaCompanyOwnership: data.usaCompanyOwnership || null,
      companyConditions: data.companyConditions || null,
      companySelectGroup: data.companySelectGroup || null,
      entityType: data.entityType || null,
      taxReturnOtherCountry: data.taxReturnOtherCountry || null,
      taxReturnOtherCountryValues: data.taxReturnOtherCountryValues || null,
      nameSecurityMarket: data.nameSecurityMarket || null,
      nameTradedCorporation: data.nameTradedCorporation || null,
      controllingPersonTaxValues: data.controllingPersonTaxValues || null
    }:{
      registeredNameCompany:null,
      newCompanyRegistrationNo: null,
      oldCompanyRegistrationNo: null,
      companyCountry: null,
      tin:null,
      sst:null,
      isCompanySameAsCorrespondence:null,
      companyAddress: null,
      countryCodeMobile: null,
      companyTel:null,
      companyEmail:null,
      insuranceCertificateDelivery:null,
      companyType: null,
      provideDetail:null,
      listedOrTradeStockExChange:null,
      fileTaxReturn:null,
      usaCompanyOwnership:null,
      companyConditions:null,
      companySelectGroup:null,
      entityType:null,
      taxReturnOtherCountry:null,
      taxReturnOtherCountryValues:null,
      nameSecurityMarket: null,
      nameTradedCorporation: null,
      controllingPersonTaxValues:null
    }
  }

  // Map data from Company detail to be auto populated  
  static getProposalAuthorisedCompanyDetails(data, dataImport) {
    //console.log("COME HEREOKK",data)
    return data ? {
      isSameAsInsuredMember:data.isSameAsInsuredMember,
      name: data.name,
      idNo: data.idNo,
      typeId: data.typeId,
      designation: data.designation,
      countryCodeMobile: data.countryCodeMobile,
      mobileNumber: data.mobileNumber,
      isSameAsInsuredMemberEmail:data.isSameAsInsuredMemberEmail,
      email: data.email
    }:{
      isSameAsInsuredMember:null,
      name: null,
      idNo: null,
      typeId: null,
      designation: null,
      countryCodeMobile: null,
      mobileNumber: null,
      email:null,
      isSameAsInsuredMemberEmail:null,
    };
  }

  static getNominationBeneficiaryDetails(data){
    return data ? {
      declareAnyBeneficiary:data.declareAnyBeneficiary,
      benificiaryAcknownledgement:data.benificiaryAcknownledgement,
      anyChild: data.anyChild,
      nominationTableValues:data.nominationTableValues,
      nominationTableOriginValues:data.nominationTableOriginValues   
    }:{
      declareAnyBeneficiary:null,
      benificiaryAcknownledgement:null,
      anyChild: null,
      nominationTableValues:null,
      nominationTableOriginValues:null     
    };
  }

  static getStepConfig(step) {
    let stepConfig = GeneralBloc.getJsonContent().quotation.quotationViewSteps[step]
    return stepConfig;
  }

  static getContactConfig() {
    let contactConfig = GeneralBloc.getJsonContent().contact
    return contactConfig;
  }

  static getContactDetailsConfig(action) {
    return {
      formName: action == "create" ? Labels.LBL_CREATE_CONTACT : Labels.LBL_UPDATE_CONTACT,
      formDesc: action == "create" ? `Fill in the details and tap on <b style='color:"1D365E";'>“Add Contact”</b> in order to create new contact.` : `Fill in the details and tap on <b style='color:"1D365E";'>“Update Contact”</b> in order to update contact.`,
      nextStep: `/${Config.context}/${Config.routes.generic.contact_details}`,
      backStep: null,
      closeStep: `/${Config.context}/${Config.routes.generic.contact}`,
      fields: {
        /* title: "title", */
        name: "name", //
        /* idNo: "idNo",
        otherIdNo: "otherIdNo", */
        dob: "dob", //
        anb: "anb",
        gender: "gender", //
        occupation: "occupation", //
        nob: "nob", //
        occupationClass: "occupationClass", //
        /* mobileNumber: "mobileNumber",
        businessContact: "businessContact",
        residenceContact: "residenceContact", */
        email: "email", //
        /* maritalStatus: "maritalStatus", */
        smoked: "smoked",
        /* corresAddress: "corresAddress",
        residentialAddress: "residentialAddress",
        residentialAddressSameCorresAddress:
          "residentialAddressSameCorresAddress",
        occupationExactDuty: "occupationExactDuty", */
        /* nationality: "nationality",
        countryCodeMobile: "countryCodeMobile",
        countryCodeResidenceTel: "countryCodeResidenceTel",
        countryCodeBusinessTel: "countryCodeBusinessTel", */
      },
      formConfig: [
        /* {
          id: "title",
        }, */
        {
          id: "name",
        },
        /* {
          id: "typeId",
        }, */
        /* {
          id: "idNo",
        },
        {
          id: "otherIdNo",
        }, */
        {
          id: "dob",
        },
        /* {
          id: "anb",
        }, */
        {
          id: "occupation",
        },
        {
          id: "nob",
        },
        {
          id: "occupationClass",
        },
        /* {
          id: "mobileNumber",
        }, */
        {
          id: "gender",
        },
        /* {
          id: "officePhoneNumber",
        }, */
        {
          id: "email",
        },
        {
          id: "smoked",
        },
        /* {
          id: "maritalStatus",
        },
        {
          id: "smoked",
        },
        {
          id: "corresAddress",
        },
        {
          id: "nationality",
        },   */
      ],
    };
  }
  /* i. Full Name (as shown in NRIC)
  ii. Date of birth (DD/MM/YYYY) --> auto populate the date from New NRIC (if available) and not editable or self input
  iii. Gender --> auto obtain from New NRIC (if available) and editable or self select
  iv. Occupation --> drop down list
  v. Occupation Class --> auto populate from Occupation selection
  vi. Nature of Business --> drop down list
  vii. Email Address --> complete email address must include "@" */
  //
  /* i. Title/Salutation ---> drop down listing
   ii. New NRIC No --> full NRIC, numeric only, no dash, auto populate or overwrite date of birth field and gender field
   iii. Old NRIC/Passport No. --> alpha-numeric allowable
   iv. Age of Next Birthday --> auto calculate from Date of birth/New NRIC if available
   v. Nationality --> auto captured as "Malaysian" if New NRIC has value or select from drop down listing
   vi. Smoker status: Yes/No --> self select
   vii. Marital Status --> drop down listing
   viii. Mobile No. (Country Code + Personal Number)
   ix. Business Contact (Country Code + Business Number)
   x. Residence Contact (Country Code + Residence Number)
   xi. Correspondence Address
   xii. Postcode
   xiii. City --> auto populate base on Postcode (if Malaysia postcode)
   xiv. State --> drop down listing
   xv. Country --> drop down listing
   xvi. Residential Address same as Correspondence Address? Yes/No.
            If yes --> system will capture Residential Address = Correspondence Address
            If no --> Residential Address Field will be made available to be filled.
   xvii. Occupation Exact Duty --> free text */
  static getContactDetailsViewConfig() {
    return {
      formName: Labels.LBL_CONTACT_DETAILS,
      formDesc: Labels.LBL_CONTACT_DETAILS_DESC,
      nextStep: `/${Config.context}/${Config.routes.generic.contact_details}`,
      backStep: `/${Config.context}/${Config.routes.generic.contact_edit}`,
      closeStep: `/${Config.context}/${Config.routes.generic.contact}`,
      fields: {
        title: "title",
        name: "name", //
        idNo: "idNo",
        otherIdNo: "otherIdNo",
        dob: "dob", //
        anb: "anb",
        gender: "gender", //
        occupation: "occupation", //
        nob: "nob", //
        occupationClass: "occupationClass", //
        mobileNumber: "mobileNumber",
        businessContact: "businessContact",
        residenceContact: "residenceContact",
        email: "email", //
        maritalStatus: "maritalStatus",
        smoked: "smoked",
        corresAddress: "corresAddress",
        residentialAddress: "residentialAddress",
        residentialAddressSameCorresAddress:
          "residentialAddressSameCorresAddress",
        occupationExactDuty: "occupationExactDuty",
        nationality: "nationality",
        countryCodeMobile: "countryCodeMobile",
        countryCodeResidenceTel: "countryCodeResidenceTel",
        countryCodeBusinessTel: "countryCodeBusinessTel",
      },
      formConfig: [
        /* {
          id: "title",
        }, */
        {
          id: "name",
        },
        /* {
          id: "typeId",
        }, */
        /* {
          id: "idNo",
        },
        {
          id: "otherIdNo",
        }, */
        {
          id: "dob",
        },
        /* {
          id: "anb",
        }, */
        {
          id: "occupation",
        },
        {
          id: "nob",
        },
        {
          id: "occupationClass",
        },
        /* {
          id: "mobileNumber",
        }, */
        {
          id: "gender",
        },
        /* {
          id: "officePhoneNumber",
        }, */
        {
          id: "email",
        },
        /* {
          id: "maritalStatus",
        },
        {
          id: "smoked",
        },
        {
          id: "corresAddress",
        },
        {
          id: "nationality",
        },   */
      ],
    };
  }

  static getProvideDetailsConfig() {
    return {
      formName: Labels.LBL_STEP1_PROVIDE_DETAILS,
      formDesc: Labels.LBL_STEP1_PROVIDE_DETAILS_DESC,
      nextStep: `/${Config.context}/${Config.routes.generic.proposal_health_questionnaries}`,
      backStep: `/${Config.context}/${Config.routes.generic.select_quotation}`,
      closeStep: `/${Config.context}/${Config.routes.generic.proposal}`,
      salesRepresentativeDetails: {
        formName: "Sales Representative Details",
        fields: {
          salesRepresentativeName: "salesRepresentativeName",
          salesRepresentativeID: "salesRepresentativeID",
          salesRepresentativeAgentCode: "salesRepresentativeAgentCode",
          branchCode: "branchCode",
          referralCode: "referralCode",
          useCampaignCode: "useCampaignCode",
          campaignCode: "campaignCode",
          useSectorCode: "useSectorCode",
          sectorCode: "sectorCode",
        },
        formConfig: [
          {
            id: "salesRepresentativeName",
          },
          {
            id: "salesRepresentativeID",
          },
          {
            id: "salesRepresentativeAgentCode",
          },
          {
            id: "referralCode",
          },
          {
            id: "branchCode",
          },
        ],
      },
      personalDetails: {
        formName: "Representative Details",
        fields: {
          name: "name",
          gender: "gender",
          idNo: "idNo",
          typeId: "typeId",
          /* otherIdNo: "otherIdNo", */
          dob: "dob",
          anb: "anb",
          maritalStatus: "maritalStatus",
          race: "race",
          nationality: "nationality",
          countryOfBirth: "countryOfBirth",
          height: "height",
          weight: "weight",
          smoked: "smoked",
          sticksPerDay: "sticksPerDay",
          yearsOfSmoked: "yearsOfSmoked",
          occupation: "occupation",
          occupationExactDuty: "occupationExactDuty",
          nob: "nob",
          annualIncome: "annualIncome",
          purposeOfProposal: "purposeOfProposal",
          relationship: "relationship",
          correspondenceAddress: "correspondenceAddress",
          residentAddress: "residentAddress",
          employerAddress: "employerAddress",
          employerName: "employerName",
          countryCodeMobile: "countryCodeMobile",
          mobileNumber: "mobileNumber",
          countryCodeBusinessTel: "countryCodeBusinessTel",
          countryCodeResidenceTel: "countryCodeResidenceTel",
          businessContact: "businessContact",
          residenceContact: "residenceContact",
          email: "email",
          insuranceCertificateDelivery: "insuranceCertificateDelivery",
          isResidentSameAsCorrespondence: "isResidentSameAsCorrespondence",
        },
        formConfig: [
          {
            id: "name",
          },
          {
            id: "gender",
          },
          {
            id: "idNo",
          },
          {
            id: "typeId",
          },
          {
            id: "dob",
          },
          {
            id: "anb",
          },
          {
            id: "nationality",
          },
          {
            id: "sticksPerDay",
          },
          {
            id: "yearsOfSmoked",
          },
          {
            id: "annualIncome",
          },
          {
            id: "isResidentSameAsCorrespondence",
          },
          {
            id: "residentAddress",
          },
          {
            id: "correspondenceAddress",
          },
          {
            id: "employerAddress",
          },
          {
            id: "maritalStatus",
          },
          {
            id: "race",
          },
          {
            id: "employerName",
          },
          {
            id: "purposeOfProposal",
          },
          {
            id: "occupationExactDuty",
          },
          {
            id: "height",
          },
          {
            id: "weight",
          },
          {
            id: "countryOfBirth",
          },
          {
            id: "countryCodeMobile",
          },
          {
            id: "mobileNumber",
          }
        ],
      },
      mortgageDetails: {
        formName: "",
        fields: {
          paymentMode: "paymentMode",
          loanAccountNo: "loanAccountNo",
          loanInterestRate: "loanInterestRate",
          premiumAmount: "premiumAmount",
          basicAmount: "basicAmount",
          ropAmount: "ropAmount",
          totalAmount: "totalAmount",
          sumAssured: "sumAssured",
          loanAmount: "loanAmount",
          termOfCoverage: "termOfCoverage",
          constructionPeriod: "constructionPeriod",
        },
        formConfig: [
          {
            id: "paymentMode",
          },
          {
            id: "loanAccountNo",
          },
          {
            id: "loanAccountNo",
          },
          /* {
            id: "loanAccountNo",
          },
          {
            id: "loanInterestRate",
          },
          {
            id: "premiumAmount",
          },
          {
            id: "basicAmount",
          },
          {
            id: "ropAmount",
          },
          {
            id: "sumAssured",
          },
          {
            id: "loanAmount",
          },
          {
            id: "termOfCoverage",
          },
          {
            id: "constructionPeriod",
          }, */
        ],
      },
      eCredit: {
        formName: "",
        fields: {
          bankAccountNo: "bankAccountNo",
          financingBank: "financingBank",
          categoryOfBank: "categoryOfBank",
          agreeChecked: "agreeChecked",
        },
        formConfig: [
          {
            id: "bankAccountNo",
          },
          {
            id: "financingBank",
          },
          {
            id: "categoryOfBank",
          },
          {
            id: "agreeChecked",
          },
        ],
      },
    };
  }

  static getHealthQuestionnariesConfig() {
    return {
      formName: Labels.LBL_STEP2_HEALTH_QUESTIONNARIES,
      formDesc: Labels.LBL_STEP2_HEALTH_QUESTIONNARIES_DESC,
      nextStep: `/${Config.context}/${Config.routes.generic.proposal_consent_declaration}`,
      backStep: `/${Config.context}/${Config.routes.generic.proposal_provide_details}`,
      closeStep: `/${Config.context}/${Config.routes.generic.proposal}`,
      personalStatement: {},
    };
  }

  static getReviewDeclaration() {
    return [
      {
        id: "1",
        sectionTitleEN: "Heath Declaration",
        sectionTitleBM: [],
        questions: [
          {
            id: "1",
            questionText:
              "1. Have you ever suffered from, advised for, investigated for, experienced symptoms, received or receiving, or intend to seek medical advice or treatment for epilepsy, mental, nervous or psychiatric disorders; chest pain / discomfort, heart attack, high blood pressure, stroke, disease or disorder of the blood, disease or disorder of the heart or blood vessels; diabetes, thyroid or any other endocrine disorder; disease or disorder of the stomach, intestines, kidney, bladder, liver, gallbladder, pancreas, urinary or digestive system; sexually transmitted disease and any disorder of the reproductive organs; disease or disorder of the eyes, ears, nose, mouth or throat; asthma, tuberculosis, sleep apnoea or any lung or respiratory disorders; cancer (including leukaemia) or abnormal growth; any disorder of muscles, bones, neck, spine, back or joint; HIV, AIDS or AIDS related conditions; or any other injury, physical defects or deformity or health impairments not mentioned here?",
            questionTextBM: "",
            selection: "yes",
            enabled: false,
            redAlertText: null,
            popUpErrorCode: "",
            canSelect: true,
            hasDialogPopup: false,
            category: "HQ",
            spanList: [],
            code: "",
            compulsoryYes: true,
            questionType: "YESNO",
            freeText: "TESTER FREE TEXT1",
            checkboxes: null,
          },
          {
            id: "2",
            questionText:
              "2. Do you intend to or currently engage in any hazardous activities such as working at heights, offshore (e.g. oil and gas), underwater or underground, use of explosives, aviation, merchant marine or taking part in dangerous sports not limited to motor racing, diving and / or parachuting?",
            questionTextBM: "",
            selection: "yes",
            enabled: false,
            redAlertText: null,
            popUpErrorCode: "",
            canSelect: true,
            hasDialogPopup: false,
            category: "HQ",
            spanList: [],
            code: "",
            compulsoryYes: true,
            questionType: "YESNO",
            freeText: "TESTER FREE TEXT2",
            checkboxes: null,
          },
          {
            id: "3",
            questionText:
              "3. Have you ever been hospitalised for any illness, injury or surgery, advised to have angiogram, echocardiogram, electrocardiogram,X-ray, blood or urine test, ultrasound, scope, CT scan, MRI, biopsy or other diagnostic test, advised or referred to see any specialist, incapacitated from work for more than seven (7) days and / or do you have any current symptoms or medical disorder for which you have not sought medical advice but intend to?",
            questionTextBM: "",
            selection: "yes",
            enabled: false,
            redAlertText: null,
            popUpErrorCode: "",
            canSelect: true,
            hasDialogPopup: false,
            category: "HQ",
            spanList: [],
            code: "",
            compulsoryYes: true,
            questionType: "YESNO",
            freeText: "TESTER FREE TEXT3",
            checkboxes: null,
          },
          {
            id: "4",
            questionText:
              "4. Have any of your proposals, reinstatements or applications been declined, deferred, accepted at special rate or terms?",
            questionTextBM: "",
            selection: "yes",
            enabled: false,
            redAlertText: null,
            popUpErrorCode: "",
            canSelect: true,
            hasDialogPopup: false,
            category: "HQ",
            spanList: [],
            code: "",
            compulsoryYes: true,
            questionType: "YESNO",
            freeText: "TESTER FREE TEXT4",
            checkboxes: null,
          },
          {
            id: "5",
            questionText:
              "5. Female only: Have you had any disorder of the breast or female organs, or complications at childbirth?",
            questionTextBM: "",
            selection: "yes",
            enabled: false,
            redAlertText: null,
            popUpErrorCode: "",
            canSelect: true,
            hasDialogPopup: false,
            category: "HQ",
            spanList: [],
            code: "",
            compulsoryYes: true,
            questionType: "YESNO",
            freeText: "TESTER FREE TEXT5",
            checkboxes: null,
          },
        ],
      },
      /* {
         "id":"2",
         "sectionTitleEN":"Consent",
         "sectionTitleBM":[
            
         ],
         "questions":[
            {
               "id":"2",
               "questionText":"I <b>give my consent</b> to Prudential Assurance Malaysia Berhad (“PAMB”), the insurer, to release my personal data to third parties for direct marketing purposes. I can withdraw my consent by letting PAMB know in writing.",
               "questionTextBM":"Saya <b>memberikan kebenaran</b> saya kepada Prudential Assurance Malaysia Berhad (“PAMB”), syarikat insurans, untuk memberi data peribadi saya kepada pihak ketiga bagi tujuan pemasaran langsung. Saya boleh menarik balik kebenaran saya pada bila-bila masa dengan memberitahu PAMB secara bertulis.",
               "selection":null,
               "enabled":false,
               "redAlertText":null,
               "popUpErrorCode":"",
               "canSelect":true,
               "hasDialogPopup":false,
               "category":"PDC",
               "spanList":[
                  
               ],
               "code":"",
               "compulsoryYes":false,
               "questionType":"YESNO",
               "checkboxes":null
            },
            {
               "id":"3",
               "questionText":"By clicking Proceed, (a) I <b>confirm</b> that I am a banking customer of United Overseas Bank (Malaysia) Bhd.; (b) I <b>acknowledge</b> I have reviewed the selected plan, the information I provided is accurate and that I have read and fully understood the <b><span id='declarations_dec'>Declarations</span></b>, <b><span id='product_materials_dec'>Product Materials</span></b> as well as <b><span id='privacy_policy_dec'>PAMB’s Privacy Policy</span></b> and I agree that they are binding on me.<br /><br /><i style=\\\"font-size:14px;\\\">Important note: It is mandatory to click and view all documents mentioned in the declaration above.</i>",
               "questionTextBM":"Dengan mengklik Seterusnya (a) saya <b>mengesahkan</b> bahawa saya adalah pelanggan perbankan United Overseas Bank (Malaysia) Bhd., (b) saya <b>mengakui</b> bahawa saya telah mengkaji pelan yang dipilih, maklumat yang diberikan adalah tepat dan saya telah membaca dan memahami sepenuhnya  <b><span id='declarations_dec'>Pengakuan</span></b>, <b><span id='product_materials_dec'>Keterangan Produk</span></b> serta <b><span id='privacy_policy_dec'>Polisi Privasi PAMB</span></b>, dan saya bersetuju bahawa maklumat tersebut mengikat saya.<br><br><i style=\\\"font-size:14px;\\\">Nota penting: Ia adalah wajib untuk mengklik dan membaca semua dokumen-dokumen yang dinyatakan di dalam pengakuan di atas.</i>",
               "selection":null,
               "enabled":false,
               "redAlertText":null,
               "popUpErrorCode":"",
               "canSelect":false,
               "hasDialogPopup":false,
               "category":"PDC",
               "spanList":[
                  {
                     "id":"Pengakuan",
                     "url":null,
                     "code":"PRU_DEC_BM"
                  },
                  {
                     "id":"Keterangan Produk",
                     "url":null,
                     "code":"PRU_PM_BM"
                  },
                  {
                     "id":"Polisi Privasi PAMB",
                     "url":null,
                     "code":"PRU_PP_BM"
                  },
                  {
                     "id":"Declarations",
                     "url":null,
                     "code":"PRU_DEC_EN"
                  },
                  {
                     "id":"Product Materials",
                     "url":null,
                     "code":"PRU_PM_EN"
                  },
                  {
                     "id":"PAMB’s Privacy Policy",
                     "url":null,
                     "code":"PRU_PP_EN"
                  }
               ],
               "code":"",
               "compulsoryYes":false,
               "questionType":null,
               "checkboxes":null
            }
         ]
      } */
    ];
  }

  static getDeclaration() {
    return [
      {
        id: "1",
        sectionTitleEN: "Heath Declaration",
        sectionTitleBM: [],
        questions: [
          {
            id: "1",
            questionText:
              "1. Have you ever suffered from, advised for, investigated for, experienced symptoms, received or receiving, or intend to seek medical advice or treatment for epilepsy, mental, nervous or psychiatric disorders; chest pain / discomfort, heart attack, high blood pressure, stroke, disease or disorder of the blood, disease or disorder of the heart or blood vessels; diabetes, thyroid or any other endocrine disorder; disease or disorder of the stomach, intestines, kidney, bladder, liver, gallbladder, pancreas, urinary or digestive system; sexually transmitted disease and any disorder of the reproductive organs; disease or disorder of the eyes, ears, nose, mouth or throat; asthma, tuberculosis, sleep apnoea or any lung or respiratory disorders; cancer (including leukaemia) or abnormal growth; any disorder of muscles, bones, neck, spine, back or joint; HIV, AIDS or AIDS related conditions; or any other injury, physical defects or deformity or health impairments not mentioned here?",
            questionTextBM:
              "1. Have you ever suffered from, advised for, investigated for, experienced symptoms, received or receiving, or intend to seek medical advice or treatment for epilepsy, mental, nervous or psychiatric disorders; chest pain / discomfort, heart attack, high blood pressure, stroke, disease or disorder of the blood, disease or disorder of the heart or blood vessels; diabetes, thyroid or any other endocrine disorder; disease or disorder of the stomach, intestines, kidney, bladder, liver, gallbladder, pancreas, urinary or digestive system; sexually transmitted disease and any disorder of the reproductive organs; disease or disorder of the eyes, ears, nose, mouth or throat; asthma, tuberculosis, sleep apnoea or any lung or respiratory disorders; cancer (including leukaemia) or abnormal growth; any disorder of muscles, bones, neck, spine, back or joint; HIV, AIDS or AIDS related conditions; or any other injury, physical defects or deformity or health impairments not mentioned here? (BM)",
            selection: null,
            enabled: true,
            redAlertText: null,
            popUpErrorCode: "",
            canSelect: true,
            hasDialogPopup: false,
            category: "HQ",
            spanList: [],
            code: "",
            compulsoryYes: true,
            questionType: "YESNO",
            freeText: "",
            checkboxes: null,
          },
          {
            id: "2",
            questionText:
              "2. Do you intend to or currently engage in any hazardous activities such as working at heights, offshore (e.g. oil and gas), underwater or underground, use of explosives, aviation, merchant marine or taking part in dangerous sports not limited to motor racing, diving and / or parachuting?",
            questionTextBM:
              "2. Do you intend to or currently engage in any hazardous activities such as working at heights, offshore (e.g. oil and gas), underwater or underground, use of explosives, aviation, merchant marine or taking part in dangerous sports not limited to motor racing, diving and / or parachuting? (BM)",
            selection: null,
            enabled: null,
            redAlertText: null,
            popUpErrorCode: "",
            canSelect: true,
            hasDialogPopup: false,
            category: "HQ",
            spanList: [],
            code: "",
            compulsoryYes: true,
            questionType: "YESNO",
            freeText: "",
            checkboxes: null,
          },
          {
            id: "3",
            questionText:
              "3. Have you ever been hospitalised for any illness, injury or surgery, advised to have angiogram, echocardiogram, electrocardiogram,X-ray, blood or urine test, ultrasound, scope, CT scan, MRI, biopsy or other diagnostic test, advised or referred to see any specialist, incapacitated from work for more than seven (7) days and / or do you have any current symptoms or medical disorder for which you have not sought medical advice but intend to?",
            questionTextBM:
              "3. Have you ever been hospitalised for any illness, injury or surgery, advised to have angiogram, echocardiogram, electrocardiogram,X-ray, blood or urine test, ultrasound, scope, CT scan, MRI, biopsy or other diagnostic test, advised or referred to see any specialist, incapacitated from work for more than seven (7) days and / or do you have any current symptoms or medical disorder for which you have not sought medical advice but intend to? (BM)",
            selection: null,
            enabled: null,
            redAlertText: null,
            popUpErrorCode: "",
            canSelect: true,
            hasDialogPopup: false,
            category: "HQ",
            spanList: [],
            code: "",
            compulsoryYes: true,
            questionType: "YESNO",
            freeText: "",
            checkboxes: null,
          },
          {
            id: "4",
            questionText:
              "4. Have any of your proposals, reinstatements or applications been declined, deferred, accepted at special rate or terms?",
            questionTextBM:
              "4. Have any of your proposals, reinstatements or applications been declined, deferred, accepted at special rate or terms? (BM)",
            selection: null,
            enabled: null,
            redAlertText: null,
            popUpErrorCode: "",
            canSelect: true,
            hasDialogPopup: false,
            category: "HQ",
            spanList: [],
            code: "",
            compulsoryYes: true,
            questionType: "YESNO",
            freeText: "",
            checkboxes: null,
          },
          {
            id: "5",
            questionText:
              "5. Female only: Have you had any disorder of the breast or female organs, or complications at childbirth?",
            questionTextBM:
              "5. Female only: Have you had any disorder of the breast or female organs, or complications at childbirth? (BM)",
            selection: null,
            enabled: null,
            redAlertText: null,
            popUpErrorCode: "",
            canSelect: true,
            hasDialogPopup: false,
            category: "HQ",
            spanList: [],
            code: "",
            compulsoryYes: true,
            questionType: "YESNO",
            freeText: "",
            checkboxes: null,
          },
        ],
      },
    ];
  }

  static getUploadDocumentsConfig() {
    return {
      formName: Labels.LBL_STEP2_UPLOAD_DOCUMENTS,
      formDesc: Labels.LBL_STEP2_UPLOAD_DOCUMENTS_DESC,
      nextStep: `/${Config.context}/${Config.routes.generic.proposal_review}`,
      backStep: `/${Config.context}/${Config.routes.generic.proposal_consent_declaration}`,
      closeStep: `/${Config.context}/${Config.routes.generic.proposal}`,
      sample: {
        title: Labels.LBL_SAMPLE_TITLE,
        desc: Labels.LBL_SAMPLE_DESC,
        note: Labels.LBL_SAMPLE_NOTE,
      },
      mandatoryDocuments: {
        title: Labels.LBL_MANDATORY_DOCUMENT,
      },
    };
  }

  static getDocumentLabelNameById(id) {
    /* if (id == "1") {
      return LanguageBloc.getTextByCode(Labels.LBL_FRONT_NRIC)
    }
    else if (id == "2") {
      return LanguageBloc.getTextByCode(Labels.LBL_BACK_NRIC)
    }
    else if (id == "3") {
      return LanguageBloc.getTextByCode(Labels.LBL_SELFIE_NRIC)
    }
    else if (id == "4") {
      return LanguageBloc.getTextByCode(Labels.LBL_PAYOR_FRONT_NRIC)
    }
    else if (id == "5") {
      return LanguageBloc.getTextByCode(Labels.LBL_PAYOR_BACK_NRIC)
    }
    else if (id == "6") {
      return LanguageBloc.getTextByCode(Labels.LBL_PAYOR_SELFIE_NRIC)
    } */
  }

  /* Client */

  static getClientAuthenticationConfig() {
    return {
      formName: Labels.LBL_AUTHENTICATION,
      formDesc: Labels.LBL_AUTHENTICATION_TITLE,
      nextStep: `/${Config.context}/client/${Config.routes.generic.verification}`,
      backStep: null,
      idNumber: Labels.LBL_ID_NUMBER,
      idNumberPlaceHolder: Labels.LBL_ID_NUMBER_PLACEHOLDER,
      remark: Labels.LBL_TERM_AND_CONDITION,
    };
  }

  static getClientVerificationConfig() {
    return {
      formName: Labels.LBL_OTP_VERIFICATION,
      formTitle: "" /* Labels.LBL_OTP_VERIFICATION_TITLE */,
      formDesc: Labels.LBL_OTP_VERIFICATION_DESC,
      notReceive: Labels.LBL_DID_NOT_RECEIVE_OTP,
      resendOTP: Labels.LBL_RESEND_OTP,
      nextStep: `/${Config.context}/client/${Config.routes.generic.client_proposal}`,
      backStep: `/${Config.context}/client/${Config.routes.generic.authentication}`,
    };
  }

  static getClientProposalConfig() {
    return {
      formName: Labels.LBL_REVIEW_SIGN,
      nextStep: `/${Config.context}/client/${Config.routes.generic.client_declaration}`,
      backStep: `/${Config.context}/client/${Config.routes.generic.verification}`,
    };
  }

  static getSignatureConfig(checked) {
    return {
      formName: Labels.LBL_REVIEW_SIGN,
      formTitle: Labels.LBL_STEP_SIGNATURE_TITLE,
      nextStep: `/${Config.context}/client/${Config.routes.generic.client_success_review}`,
      backStep: `/${Config.context}/client/${Config.routes.generic.client_declaration}`,
      fields: ["confirm_signature"],
      checkboxes: [
        {
          id: "confirm_signature",
          title: null,
          desc: Labels.LBL_SIGNATURE_DECLARATION,
          options: null,
          status: !checked,
        },
      ],
    };
  }

  static getReviewAndSignDeclarationConfig(checked) {
    return {
      formName: Labels.LBL_STEP_DECLARATION_AND_SIGN,
      formTitle: Labels.LBL_STEP_DECLARATION_TITLE,
      formDesc: Labels.LBL_STEP_DECLARATION_DESC,
      nextStep: `/${Config.context}/client/${Config.routes.generic.client_success_review}`,
      backStep: `/${Config.context}/client/${Config.routes.generic.client_proposal}`,
      fields: [],
      checkboxes: [
        {
          id: "1",
          title: null,
          desc: Labels.LBL_DECLARATION_ACKNOWLEGDE,
          options: null,
          status: !checked,
          showCheckbox:false,
          compulsory: false,
          requiredClickedDocument: true,
          tooltip: Labels.LBL_DECLARATION_ACKNOWLEGDE_TOOLTIP
        },
        {
          id: "2",
          title: null,
          desc: Labels.LBL_DECLARATION_ACKNOWLEGDE2,
          status: !checked,
          showCheckbox:false,
          compulsory: false,
        },
        {
          id: "3",
          title: null,
          desc: Labels.LBL_DECLARATION_ACKNOWLEGDE3,
          status: !checked,
          showCheckbox:false,
          compulsory: false,
        }/* ,
        {
          id: "4",
          title: null,
          desc: Labels.LBL_DECLARATION_IMPORTANT_NOTE,
          status: !checked,
          compulsory: false,
          requiredClickedDocument:true,
          tooltip:Labels.LBL_DECLARATION_IMPORTANT_TOOLTIP
        }, */
      ],
    };
  }

  static getRemarkDeclarationProposalDetailConfig(remarkDeclarationProposalDetailConfig,status) {    
    //console.log("remarkDeclarationProposalDetailConfig",remarkDeclarationProposalDetailConfig)
    remarkDeclarationProposalDetailConfig && remarkDeclarationProposalDetailConfig.checkboxes.map((ev)=>{
      ev.status=status;
    })
    return remarkDeclarationProposalDetailConfig;
  }

  static getRemarkDeclarationProposalDetailConfigSupervisorOrCAC() {
    return {
      fields: ["1", "2", "3"],
      checkboxes: [
        {
          id: "1",
          title: null,
          desc: "I declare that the information in the enrolment form is the only information given to me relating to the person(s) applying for assurance and I have not withheld any other information which might influence PAMB’s acceptance of this enrolment.",
          options: null,
          status: true,
          compulsory: true,
        },
        {
          id: "2",
          title: null,
          desc: "I declare that I have sighted the original NRIC/birth certificate/passport/corporate’s documents such as certificate of incorporation, Forms 24 & 49, and verified the identity of the above persons/corporate entity.",
          status: true,
          compulsory: true,
        },
        {
          id: "3",
          title: null,
          desc: "I declare that I have given and explained adequately product disclosure sheet, brochures (if any), sales illustrations (if any) and other marketing materials (if any) to the person applying for assurance.",
          status: true,
          compulsory: true,
        },
      ],
    };
  }

  static getRemarkDeclarationProposalDetailConfigExtra(status) {
    return {
      fields: ["1"],
      checkboxes: [
        {
          id: "1",
          title: null,
          desc: "<span style='color:red;'>*</span> I confirm and declare that the signature in the signature box above is my signature and is for insurance application through PRUConnect. I also declare that I fully understand and agree with all the information and declarations in the attached documents.",
          options: null,
          status: status,
          compulsory: true,
        }
      ],
    };
  }

  static getRemarkDeclarationProposalDetailConfigExtraSuperVisorOrCAC() {
    return {
      fields: ["1"],
      checkboxes: [
        {
          id: "1",
          title: null,
          desc: "<span style='color:red;'>*</span> I confirm and declare that the signature in the signature box above is my signature and is for insurance application through PRUConnect. I also declare that I fully understand and agree with all the information and declarations in the attached documents.",
          options: null,
          status: true,
          compulsory: true,
        }
      ],
    };
  }

  /*  */

  static getReviewDetailsConfig() {
    return {
      formName: Labels.LBL_STEP3_REVIEW,
      formDesc: Labels.LBL_STEP3_REVIEW_DESC,
      nextStep: `/${Config.context}/${Config.routes.generic.proposal_consent_declaration}`,
      backStep: `/${Config.context}/${Config.routes.generic.proposal_upload_documents}`,
      closeStep: `/${Config.context}/${Config.routes.generic.proposal}`,
    };
  }

  static getReviewDetailsConfigClient() {
    return {
      formName: Labels.LBL_REVIEW,
      formDesc: Labels.LBL_STEP3_REVIEW_DESC,
      nextStep: `/${Config.context}/${Config.routes.generic.client_declaration_and_sign}`,
      backStep: `/${Config.context}/${Config.routes.generic.authentication}`,
      closeStep: `/${Config.context}/${Config.routes.generic.proposal}`,
    };
  }

  static getConsentDeclarationConfig() {
    return {
      formName: Labels.LBL_STEP4_CONSENT_DECLARATION,
      formDesc: Labels.LBL_STEP4_CONSENT_DECLARATION_DESC,
      nextStep: `/${Config.context}/${Config.routes.generic.proposal_upload_documents}`,
      backStep: `/${Config.context}/${Config.routes.generic.proposal_health_questionnaries}`,
      closeStep: `/${Config.context}/${Config.routes.generic.proposal}`,
      remark: Labels.LBL_SEND_REVIEW_REMARK,
      fields: [
        "coveredConsent",
        "coveredConsent1",
        "coveredConsent2",
        "coveredConsent21",
        "coveredConsent22",
        "coveredConsent31",
        "coveredConsent32",
        "coveredConsent33",
        "coveredConsent34",
        "coveredConsent35",
        "coveredConsent36",
        "coveredConsent37",
        "coveredConsent41",
        "coveredConsent42",
        "coveredConsent43",
      ],
      section1Checkboxes: [
        {
          id: "coveredConsent",
          title: Labels.LBL_SECTION1_1_DECLARATION_TITLE,
          desc: Labels.LBL_SECTION1_1_DECLARATION_DESC,
          options: null,
          status: false,
          compulsory: true,
        },
        {
          id: "coveredConsent1",
          title: Labels.LBL_SECTION1_2_DECLARATION_TITLE,
          desc: Labels.LBL_SECTION1_2_DECLARATION_DESC,
          options: null,
          status: false,
          compulsory: true,
          showCheckbox: true
        },
        {
          id: "coveredConsent2",
          title: Labels.LBL_SECTION1_3_DECLARATION_TITLE,
          desc: Labels.LBL_SECTION1_3_DECLARATION_DESC,
          options: null,
          status: false,
          compulsory: true,
        },
      ],
      section2Checkboxes: [
        {
          id: "coveredConsent21",
          title: Labels.LBL_SECTION2_1_DECLARATION_TITLE,
          desc: Labels.LBL_SECTION2_1_DECLARATION_DESC,
          options: null,
          status: false,
          compulsory: true,
        },
        {
          id: "coveredConsent22",
          title: Labels.LBL_SECTION2_2_DECLARATION_TITLE,
          desc: Labels.LBL_SECTION2_2_DECLARATION_DESC,
          options: null,
          status: false,
          compulsory: true,
        },
        {
          id: "coveredConsent23",
          title: Labels.LBL_SECTION2_3_DECLARATION_TITLE,
          desc: Labels.LBL_SECTION2_3_DECLARATION_DESC,
          options: null,
          status: false,
          compulsory: false,
          showCheckbox: false
        },
        {
          id: "coveredConsent24",
          title: Labels.LBL_SECTION2_4_DECLARATION_TITLE,
          desc: Labels.LBL_SECTION2_4_DECLARATION_DESC,
          options: null,
          status: false,
          compulsory: false,
          showCheckbox: false
        },
      ],
      section3Checkboxes: [
        {
          id: "coveredConsent31",
          title: Labels.LBL_SECTION3_1_DECLARATION_TITLE,
          desc: Labels.LBL_SECTION3_1_DECLARATION_DESC,
          options: null,
          status: false,
          compulsory: true,
        },
        {
          id: "coveredConsent32",
          title: Labels.LBL_SECTION3_2_DECLARATION_TITLE,
          desc: Labels.LBL_SECTION3_2_DECLARATION_DESC,
          options: null,
          status: false,
          compulsory: false,
        },
        {
          id: "coveredConsent33",
          title: Labels.LBL_SECTION3_3_DECLARATION_TITLE,
          desc: Labels.LBL_SECTION3_3_DECLARATION_DESC,
          options: null,
          status: false,
          compulsory: true,
        },
        {
          id: "coveredConsent34",
          title: Labels.LBL_SECTION3_4_DECLARATION_TITLE,
          desc: Labels.LBL_SECTION3_4_DECLARATION_DESC,
          options: null,
          status: false,
          compulsory: true,
        },
        {
          id: "coveredConsent35",
          title: Labels.LBL_SECTION3_5_DECLARATION_TITLE,
          desc: Labels.LBL_SECTION3_5_DECLARATION_DESC,
          options: null,
          status: false,
          compulsory: true,
        },
        {
          id: "coveredConsent36",
          title: Labels.LBL_SECTION3_6_DECLARATION_TITLE,
          desc: Labels.LBL_SECTION3_6_DECLARATION_DESC,
          options: null,
          status: false,
          compulsory: true,
        },
        {
          id: "coveredConsent37",
          title: Labels.LBL_SECTION3_7_DECLARATION_TITLE,
          desc: Labels.LBL_SECTION3_7_DECLARATION_DESC,
          options: null,
          status: false,
          compulsory: true,
        },
      ],
      section4Checkboxes: [
        {
          id: "coveredConsent41",
          title: Labels.LBL_SECTION4_1_DECLARATION_TITLE,
          desc: Labels.LBL_SECTION4_1_DECLARATION_DESC,
          options: null,
          status: false,
          compulsory: true,
        },
        {
          id: "coveredConsent42",
          title: Labels.LBL_SECTION4_2_DECLARATION_TITLE,
          desc: Labels.LBL_SECTION4_2_DECLARATION_DESC,
          options: null,
          status: false,
          compulsory: true,
        },
        {
          id: "coveredConsent43",
          title: Labels.LBL_SECTION4_3_DECLARATION_TITLE,
          desc: Labels.LBL_SECTION4_3_DECLARATION_DESC,
          options: null,
          status: false,
          compulsory: true,
        },
      ],
    };
  }

  /* static getFinancialDetailsConfig() {
    return {
      formName: Labels.LBL_STEP2_FINANCIAL_DETAILS,
      formDesc: Labels.LBL_STEP2_FINANCIAL_DETAILS_DESC,
      nextStep: `/${Config.context}/${Config.routes.generic.quotation_takaful_details}`,
      backStep: `/${Config.context}/${Config.routes.generic.quotation_personal_details}`,
      closeStep: `/${Config.context}/${Config.routes.generic.quotation}`,
      fields: {
        productSelection: "productSelection",
        paymentFrequency: "paymentFrequency",
        paymentMode: "paymentMode",
        paymentMethod: "paymentMethod",
        anb: "anb",
        premiumBackDate: "premiumBackDate",
        inceptionDate: "inceptionDate",        
      },
      formConfig: [
        {
          id: "productSelection",
        },
        {
          id: "paymentFrequency",
        },
        {
          id: "paymentMode",
        },
        {
          id: "paymentMethod",
        },
        {
          id: "anb",
        },
        {
          id: "premiumBackDate",
        },
        {
          id: "inceptionDate",
        }
      ],
    };
  }
 */

  static getFinancialDetailsConfig() {
    return {
      formName: Labels.LBL_STEP2_FINANCIAL_DETAILS,
      formDesc: Labels.LBL_STEP2_FINANCIAL_DETAILS_DESC,
      nextStep: `/${Config.context}/${Config.routes.generic.quotation_review_submit}`,
      backStep: `/${Config.context}/${Config.routes.generic.quotation_personal_details}`,
      closeStep: `/${Config.context}/${Config.routes.generic.quotation}`,
      productSelection: {
        formName: "Product Selection",
        fields: {
          productSelection: "productSelection",
          paymentFrequency: "paymentFrequency",
          paymentMode: "paymentMode",
          paymentMethod: "paymentMethod",
          anb: "anb",
          premiumBackDate: "premiumBackDate",
          inceptionDate: "inceptionDate",
        },
        formConfig: [
          {
            id: "productSelection",
          },
          {
            id: "paymentFrequency",
          },
          {
            id: "paymentMode",
          },
          {
            id: "paymentMethod",
          },
          {
            id: "anb",
          },
          {
            id: "premiumBackDate",
          },
          {
            id: "inceptionDate",
          },
        ],
      },
      mortgageCover: {
        formName: "Mortgage Cover",
        fields: {
          loanAccountNo: "loanAccountNo",
          loanAmount: "loanAmount",
          loanTenure: "loanTenure",
          constructionPeriod: "constructionPeriod",
          loanInterestRate: "loanInterestRate",
          /*  productName: "productName", */
          initialSumAssured: "initialSumAssured",
          termOfCoverage: "termOfCoverage",
          defermentTerm: "defermentTerm",
          refundOfPremiumRider: "refundOfPremiumRider",
        },
        formConfig: [
          {
            id: "loanAccountNo",
          },
          {
            id: "loanAmount",
          },
          {
            id: "loanTenure",
          },
          {
            id: "constructionPeriod",
          },
          {
            id: "loanInterestRate",
          },
          /*  {
            id: "productName",
          }, */
          {
            id: "initialSumAssured",
          },
          {
            id: "termOfCoverage",
          },
          {
            id: "defermentTerm",
          },
          {
            id: "refundOfPremiumRider",
          },
        ],
      },
    };
  }

  static getTakafulDetailsConfig() {
    return {
      formName: Labels.LBL_STEP3_TAKAFUL_DETAILS,
      formDesc: Labels.LBL_STEP3_TAKAFUL_DETAILS_DESC,
      nextStep: `/${Config.context}/${Config.routes.generic.quotation_review_submit}`,
      backStep: `/${Config.context}/${Config.routes.generic.quotation_financial_details}`,
      closeStep: `/${Config.context}/${Config.routes.generic.quotation}`,
      fields: {
        termOfCoverage: "termOfCoverage",
        initialSumCovered: "initialSumCovered",
        contributionAmount: "contributionAmount",
        contributionMode: "contributionMode",
        contributionType: "contributionType",
      },
      formConfig: [
        {
          id: "termOfCoverage",
        },
        {
          id: "initialSumCovered",
        },
        {
          id: "contributionAmount",
        },
        {
          id: "contributionMode",
        },
        {
          id: "contributionType",
        },
      ],
    };
  }

  static getReviewAndSubmitDetailsConfig() {
    return {
      formName: Labels.LBL_STEP3_REVIEW_SUBMIT,
      formDesc: Labels.LBL_STEP3_REVIEW_SUBMIT_DESC,
      nextStep: `/${Config.context}/${Config.routes.generic.quotation}`,
      backStep: `/${Config.context}/${Config.routes.generic.quotation_financial_details}`,
      closeStep: `/${Config.context}/${Config.routes.generic.quotation}`,
    };
  }
}
